import React, { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../../hooks/react-redux';
import { Sort } from '../../../../shared/icons';
import { ConfirmationModal } from '../../../../shared/modal/ConfirmationModal';
import { ModalHeader } from '../../../../shared/modal/ModalHeader';
import { getCurrentPriorityOrder, getPriorityModalOpen, getPriorityOrderHasUpdated, togglePriorityOrderModalOpen, updateFewShotPriorityOrderStarted } from '../store';
import { FewShotPriority } from './FewShotPriority';
import styles from './FewShotPriority.module.scss';

export const PriorityModal: React.FC = () => {
    const dispatch = useAppDispatch();
    const currentPriorityOrder = useAppSelector(getCurrentPriorityOrder);
    const isOpen = useAppSelector(getPriorityModalOpen);
    const hasUpdated = useAppSelector(getPriorityOrderHasUpdated);

    const closeModal = useCallback(() => dispatch(togglePriorityOrderModalOpen(false)), [dispatch]);
    const savePriorityOrder = useCallback(() => dispatch(updateFewShotPriorityOrderStarted()), [dispatch]);

    return (
        <ConfirmationModal
            isOpen={isOpen}
            closeOnOverlayClick={false}
            closeModal={closeModal}
            confirm={savePriorityOrder}
            confirmDisabled={!hasUpdated}
            confirmLabel='Save'
            closeLabel='Close'
        >
            <div className={styles.priorityModalWrapper} data-testid='few-shot-document-priority-modal-wrapper'>
                <ModalHeader label='Specify System Few Shot Document Priority' icon={Sort} />
                <div className={styles.priorityWrapper}>
                    <FewShotPriority priorityOrder={currentPriorityOrder} />
                </div>
            </div>
        </ConfirmationModal>
    );
};
